import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { getCurrentUser } from "@/store-redux";
import { IQueryOptions } from ".";
import {
  getMyPractices,
  getQuotaPractice,
  grammarVocabularyPractice,
  postPracticeEvaluate,
  postPracticeTranscribe,
  postWordMatchEvaluate,
  sendAudioPractice,
  pronunciationAnalyze,
  postCheckQuestion,
} from "../api";

export const useCheckQuestion = (options: IQueryOptions = {}) => {
  return useMutation(postCheckQuestion, options);
};

export const useUploadFilePractice = (options: IQueryOptions) => {
  return useMutation(sendAudioPractice, options);
};

export const usePracticeTranscribe = (options: IQueryOptions) => {
  return useMutation(postPracticeTranscribe, options);
};

export const usePracticeEvaluate = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(postPracticeEvaluate, {
    ...options,
    onSuccess: (data) => {
      dispatch(getCurrentUser());
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
  });
};

export const useGetQuotaPractice = (options: IQueryOptions) => {
  return useQuery(["fetchQuotaPractice"], () => getQuotaPractice(), {
    enabled: true,
    keepPreviousData: true,
    ...options,
  });
};

export const useGetMyPractices = (options: IQueryOptions) => {
  return useQuery(["fetchMyPractices"], () => getMyPractices(), {
    enabled: true,
    keepPreviousData: true,
    ...options,
  });
};

export const useWordMatchEvaluate = (options: IQueryOptions) => {
  return useMutation(postWordMatchEvaluate, options);
};

export const useGrammarVocabularyPractice = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(grammarVocabularyPractice, {
    ...options,
    onSuccess: (data) => {
      dispatch(getCurrentUser());
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
  });
};

export const usePronunciationAnalyze = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(pronunciationAnalyze, {
    ...options,
    onSuccess: (data) => {
      dispatch(getCurrentUser());
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
  });
};
